<template>
    <iframe
        :title="name"
        style="width: 400px; height: 152px; margin: 0 auto;"
        :src="getUrl()"
    />
</template>

<script>
    // Library
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'BandcampPlayer',

        props: {
            name: {
                type: String,
                required: true,
            },

            route: {
                type: String,
                required: true,
            },

            isTrack: {
                type: Boolean,
                required: false,
            },
        },

        methods: {
            getUrl() {
                return `https://bandcamp.com/EmbeddedPlayer/${this.isTrack ? 'track' : 'album'}=${this.route}/size=large/bgcol=050810/linkcol=dbe2ec/tracklist=false/artwork=small/transparent=true/`;
            },
        },
    });
</script>
